import type { Accessible } from "@src/common/AccessibleStore";
import { accessible } from "@src/common/AccessibleStore";
import { MapStore } from "@src/common/MapStore";
import { TimeStamp, TimeStampType } from "@src/common/TimeStamp";

export enum InteractionPointType {
    INFO = 1,
    CHOOSE = 2,
    PROMPT = 3,
    GOTO = 4,
    // 不直接显示但是会在背后进行某些操作的（e.g. 数据埋点，记录次数/好感度之类的东西）
    BACKGROUND = 100,
}

export type InteractionPoint =
    { type: InteractionPointType.INFO, around: TimeStampType,
        text: string,
        [key: string]: any }
    | { type: InteractionPointType.CHOOSE, around: TimeStampType,
        choices: { id: string, text: string, target: TimeStampType }[],
        [key: string]: any }
    | { type: InteractionPointType.PROMPT, around: TimeStampType,
        prompt: string,
        [key: string]: any }
    | { type: InteractionPointType.GOTO, around: TimeStampType,
        target: TimeStampType,
        [key: string]: any }
    | { type: InteractionPointType.BACKGROUND, around: TimeStampType,
        data: any,
        [key: string]: any }

export type MainStoreType = {
    currentVideoSource: Accessible<string>,
    currentVideoTimeStamp: Accessible<TimeStampType>,
    currentVideoLength: Accessible<number>,
    currentInteractionPointList: Accessible<InteractionPoint[]>,
    currentExecutingInteractionPoint: Accessible<InteractionPoint|undefined>,
    _currentVideoElement: HTMLVideoElement|undefined,
    currentSessionData: MapStore,
}

function _MainStore() {
    const { subscribe, getValue, set, update } = accessible<MainStoreType>({
        currentVideoSource: accessible(''),
        currentVideoTimeStamp: accessible(0),
        currentVideoLength: accessible(0),
        currentInteractionPointList: accessible([]),
        currentExecutingInteractionPoint: accessible(undefined),
        _currentVideoElement: undefined,
        currentSessionData: new MapStore(),
    });
    return {
        subscribe,
        getValue,
        reset: () => {
            let x = getValue();
            x.currentVideoSource.set("");
            x.currentVideoTimeStamp.set(0);
            x.currentInteractionPointList.set([]);
            x.currentExecutingInteractionPoint.set(undefined);
            x._currentVideoElement = undefined;
            x.currentSessionData = new MapStore();
        },
        setVideoSource: (x: string) => {
            if (getValue().currentVideoSource.getValue() !== x) {
                getValue().currentVideoSource.set(x);
            }
        },
        setVideoTimeStamp: (x: TimeStampType) => {
            getValue().currentVideoTimeStamp.set(x);
        },
        setVideoLength: (x: number) => {
            console.log(`Video length:`, x);
            getValue().currentVideoLength.set(x);
        },
        setCurrentExecutingInteractionPoint: (x: InteractionPoint) => {
            getValue().currentExecutingInteractionPoint.set(x);
        },
        dump: () => {
            let interactionPoint = getValue().currentInteractionPointList.getValue().map((v) => {
                let res: {[key: string]: any} = {
                    around: TimeStamp.toString(v.around)
                };
                switch (v.type) {
                    case InteractionPointType.INFO: {
                        res.info = {...v};
                        delete res.info.around;
                        delete res.info.type;
                        break;
                    }
                    case InteractionPointType.PROMPT: {
                        res.prompt = {...v};
                        delete res.prompt.around;
                        delete res.prompt.type;
                        break;
                    }
                    case InteractionPointType.CHOOSE: {
                        res.choose = {...v};
                        res.choose.choices.forEach((v) => {
                            v.target = TimeStamp.toString(v.target);
                        });
                        delete res.choose.around;
                        delete res.choose.type;
                        break;
                    }
                }
                return res;
            });
            return {
                main: {
                    video_src: getValue().currentVideoSource.getValue(),
                    interact: interactionPoint,
                }
            };
        },
        resetOverlay: () => {
            getValue().currentExecutingInteractionPoint.set(undefined);
        }
    }
}

let store = _MainStore();

const TIMESTAMP_DELTA = 0.004;
export function _FindInteractionPointAround(x: TimeStampType) {
    return store.getValue().currentInteractionPointList.getValue().find((v) => Math.abs(v.around - x) < TIMESTAMP_DELTA);
}

export default store;

